import React from 'react'

export default function Modification_date() {
    return (
        <div>
            <h1>Transaction Modification Date </h1>
        </div>
    )
}
